// 暂无使用（20220921）
export const defineDirective = (app) => {
  app.directive('backgroundPermission', (el, binding) => {
    const backgroundStaffOperate = JSON.parse(window.localStorage.getItem('wp_userInfo'))?.background_role_permission?.operate
    // 如果按钮本身就是禁用状态，那就直接返回
    // // 如果员工可以进行操作
    if (backgroundStaffOperate) {
      // 实现按钮禁用
      el.style.display = ''
    }
    // 不可以操作
    if (!backgroundStaffOperate) {
      el.style.display = 'none'
    }
  })
}
